module.exports = __webpack_public_path__ + "img/Sleeves-Front-B9-Da-Ea-Gb.03b1314b.png";